var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#007179",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15.2,
    cy: 8.4,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.875 1.563h-1.016V.78a.781.781 0 1 0-1.562 0v.781h-3.555v-.78a.781.781 0 1 0-1.562 0v.78H5.664v-.78a.781.781 0 1 0-1.562 0v.78h-.977A3.129 3.129 0 0 0 0 4.688v12.188A3.129 3.129 0 0 0 3.125 20h5.977a.781.781 0 1 0 0-1.563H3.125c-.862 0-1.563-.7-1.563-1.562V4.687c0-.861.701-1.562 1.563-1.562h.977v.781a.781.781 0 1 0 1.562 0v-.781H9.18v.781a.781.781 0 1 0 1.562 0v-.781h3.555v.781a.781.781 0 1 0 1.562 0v-.781h1.016c.862 0 1.563.7 1.563 1.563V9.14a.781.781 0 1 0 1.562 0V4.687a3.129 3.129 0 0 0-3.125-3.125z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2 10.4a4.805 4.805 0 0 0-4.8 4.8c0 2.647 2.153 4.8 4.8 4.8s4.8-2.153 4.8-4.8-2.153-4.8-4.8-4.8zm0 8.013a3.217 3.217 0 0 1-3.213-3.213 3.217 3.217 0 0 1 3.213-3.213 3.217 3.217 0 0 1 3.213 3.213 3.217 3.217 0 0 1-3.213 3.213z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.388 14.42h-.365v-.83a.801.801 0 0 0-.811-.79.801.801 0 0 0-.812.79v1.62c0 .436.363.79.812.79h1.176a.801.801 0 0 0 .812-.79.801.801 0 0 0-.812-.79z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.6,
    cy: 8.4,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.4,
    cy: 11.6,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.8,
    cy: 8.4,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.8,
    cy: 11.6,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.8,
    cy: 15.2,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.4,
    cy: 15.2,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.4,
    cy: 8.4,
    r: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.d0d9d4f1e84ed6069a93513d11c1fcca.svg";
export { ForwardRef as ReactComponent };